import { Globe, BarChart3, Database } from 'lucide-react';
import { ManageSearch } from '@mui/icons-material';
import type { SuggestedCategory } from '@/types/chat';

/** The 4 action category buttons shown on the landing. */
export const SUGGESTED_CATEGORIES: SuggestedCategory[] = [
  { id: 'getting-started', label: 'Getting Started', icon: Globe },
  { id: 'asset-querying', label: 'Asset Querying', icon: Database },
  {
    id: 'inspection-status-coverage',
    label: 'Inspection Status & Coverage',
    icon: ManageSearch,
  },
  { id: 'data-visualization', label: 'Data Visualization', icon: BarChart3 },
];

/** Prompts shown in the dropdown for each category (4 per category). Key = category id. */
export const PROMPTS_BY_CATEGORY: Record<string, string[]> = {
  'getting-started': [
    'How can you help me today?',
    'What can you do with my water network data?',
    'How do I get help with inspections and condition data?',
    'Where can I find documentation for modeling and risk assessment?',
  ],
  'asset-querying': [
    'How many pipes are there in my network?',
    'What is the total mileage (or km) of my network?',
    'How many pipes are of PVC material?',
    'How many pipes are there larger than 12 inch diameter?',
  ],
  'inspection-status-coverage': [
    'Calculate the % of my network in terms of length that has not been inspected.',
    'How many pipes with CCTV inspection?',
    'How many pipes without CCTV inspection?',
    'Which pipes were inspected this year?',
  ],
  'data-visualization': [
    'Create a pie chart that shows the likelihood/consequence of failure breakdown.',
    "Create a pie chart that shows the status of pipes that have CCTV and those that don't.",
    'Show me a histogram grouping the number of pipes and the risk category.',
    'Give me an overall summary of my network results so I can send it to my supervisor.',
  ],
};
